import React from "react";
import { useTranslation } from "react-i18next";
import { Inbox } from "lucide-react";

/**
 * EmptyState — calm zero-state for activity feeds.
 *
 * Tone: reassuring, not apologetic. "Nothing to worry about" rather than
 * "no data found."
 */
export const EmptyState = ({ titleKey, hintKey }) => {
    const { t } = useTranslation();
    return (
        <div
            data-testid="ob-activity-empty"
            className="ob-card p-10 text-center space-y-3"
        >
            <div
                className="mx-auto w-12 h-12 rounded-full flex items-center justify-center"
                style={{ background: "rgba(255,255,255,0.04)" }}
                aria-hidden="true"
            >
                <Inbox size={20} strokeWidth={1.5} style={{ color: "var(--ob-text-tertiary)" }} />
            </div>
            <h3 className="text-lg" style={{ color: "var(--ob-text-primary)", fontFamily: "Outfit, sans-serif" }}>
                {t(titleKey || "ob.activity.empty.title")}
            </h3>
            <p className="text-sm" style={{ color: "var(--ob-text-tertiary)" }}>
                {t(hintKey || "ob.activity.empty.hint")}
            </p>
        </div>
    );
};
